import { RouteInfo } from './sidebar.metadata';

export const ROUTES: RouteInfo[] = [

  {
    path: '/dashboard/home', title: 'Estadisticas', icon: 'mdi mdi-home', class: '', label: '', labelClass: '', extralink: false, submenu: []
  },
  // Valores reales
  {
      path: '', title: 'Accesos y Contraseñas', icon: '', class: 'nav-small-cap', label: '', labelClass: '', extralink: true, submenu: []
  },
  {
    path: '/servers', title: 'Servidores', icon: 'mdi mdi-gauge', class: '', label: '', labelClass: '', extralink: false, submenu: []
  },
  {
      path: '', title: 'Dominios', icon: 'mdi mdi-web', class: 'has-arrow', label: '', labelClass: '', extralink: false,
      submenu: [
          { path: '/domains', title: 'Todos', icon: '', class: '', label: '', labelClass: '', extralink: false, submenu: [] },
          { path: '/domains/cyberneticos', title: 'Cyberneticos', icon: '', class: '', label: '', labelClass: '', extralink: false, submenu: [] },
          { path: '/domains/ovh', title: 'OVH', icon: '', class: '', label: '', labelClass: '', extralink: false, submenu: [] },
          { path: '/domains/hostgator-3058', title: 'Hostgator 3058', icon: '', class: '', label: '', labelClass: '', extralink: false, submenu: [] },
          { path: '/domains/hostgator-2005', title: 'Hostgator 2005', icon: '', class: '', label: '', labelClass: '', extralink: false, submenu: [] },
          { path: '/domains/extras', title: 'Extras', icon: '', class: '', label: '', labelClass: '', extralink: false, submenu: [] },
      ]
  },
  {
    path: '/subdomains', title: 'Subdominios', icon: 'mdi mdi-search-web', class: '', label: '', labelClass: '', extralink: false, submenu: []
  },
  {
    path: '/networks', title: 'Redes Sociales', icon: 'mdi mdi-earth', class: '', label: '', labelClass: '', extralink: false, submenu: []
  },
  {
    path: '/android', title: 'Android Keys', icon: 'mdi mdi-android', class: '', label: '', labelClass: '', extralink: false, submenu: []
  },
  {
    path: '/tools', title: 'Herramientas', icon: 'mdi mdi-wrench', class: '', label: '', labelClass: '', extralink: false, submenu: []
  },
  {
      path: '', title: 'Mantenimiento', icon: '', class: 'nav-small-cap', label: '', labelClass: '', extralink: true, submenu: []
  },
  {
      path: '', title: 'Bases de Datos', icon: 'mdi mdi-database', class: 'has-arrow', label: '', labelClass: '', extralink: false,
      submenu: [
          { path: '/databases/cyberneticos', title: 'Cyberneticos', icon: '', class: '', label: '', labelClass: '', extralink: false, submenu: [] },
          { path: '/databases/ovh', title: 'OVH', icon: '', class: '', label: '', labelClass: '', extralink: false, submenu: [] },
          { path: '/databases/hostgator-3058', title: 'Hostgator 3058', icon: '', class: '', label: '', labelClass: '', extralink: false, submenu: [] },
          { path: '/databases/hostgator-2005', title: 'Hostgator 2005', icon: '', class: '', label: '', labelClass: '', extralink: false, submenu: [] },
          { path: '/databases/extras', title: 'Extras', icon: '', class: '', label: '', labelClass: '', extralink: false, submenu: [] },
      ]
  },
  {
      path: '', title: 'Respaldos', icon: 'mdi mdi-server', class: 'has-arrow', label: '', labelClass: '', extralink: false,
      submenu: [
          { path: '/backups/cyberneticos', title: 'Cyberneticos', icon: '', class: '', label: '', labelClass: '', extralink: false, submenu: [] },
          { path: '/backups/ovh', title: 'OVH', icon: '', class: '', label: '', labelClass: '', extralink: false, submenu: [] },
          { path: '/backups/hostgator-3058', title: 'Hostgator 3058', icon: '', class: '', label: '', labelClass: '', extralink: false, submenu: [] },
          { path: '/backups/hostgator-2005', title: 'Hostgator 2005', icon: '', class: '', label: '', labelClass: '', extralink: false, submenu: [] },
          { path: '/backups/extras', title: 'Extras', icon: '', class: '', label: '', labelClass: '', extralink: false, submenu: [] },
      ]
  },
//************************
  {
      path: '', title: 'Extras', icon: '', class: 'nav-small-cap', label: '', labelClass: '', extralink: true, submenu: []
  },
  {
      path: '/quotations/storage', title: 'Inventario', icon: 'mdi mdi-store', class: '', label: '', labelClass: '', extralink: false, submenu: []
  },
  {
    path: '/users/list', title: 'Usuarios', icon: 'mdi mdi-account', class: '', label: '', labelClass: '', extralink: false, submenu: []
  },
  {
    path: '/resources/notifications', title: 'Mensajes', icon: 'mdi mdi-message-bulleted', class: '', label: '', labelClass: '', extralink: false, submenu: []
  },
  {
    path: '/resources/manuals', title: 'Manuales', icon: 'mdi mdi-note-text', class: '', label: '', labelClass: '', extralink: false, submenu: []
  },
];
